import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../common/Logo';

const Header = ({ activeTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const tabs = [
    { id: 'home', label: 'Home', path: '/' },
    { id: 'about', label: 'About Us', path: '/about' },
    { id: 'academics', label: 'Academics', path: '/academics' },
    { id: 'admission', label: 'Admission', path: '/admission' },
    { id: 'placements', label: 'Training & Placements', path: '/placements' },
    { id: 'research', label: 'Research & Development', path: '/research' },
    { id: 'events', label: 'Events & Happenings', path: '/events' },
    { id: 'contact', label: 'Contact', path: '/contact' }
  ];

  return (
    <header className="bg-white border-b border-border_gray shadow-sm z-30 relative">
      <div className="absolute top-0 left-0 w-full h-1 bg-brand-gradient"></div>
      
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0">
              <Logo />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className={`${isDesktop ? 'flex' : 'hidden'} items-center ml-4 lg:ml-8`}
               style={{
                 display: isDesktop ? 'flex' : 'none',
                 alignItems: 'center',
                 gap: '2px',
                 marginLeft: 'auto',
                 flexWrap: 'wrap'
               }}>
          {tabs.map((tab) => {
            if (tab.id === 'about') {
              return (
                <div 
                  key={tab.id}
                  className="relative group"
                  onMouseEnter={() => setShowAboutDropdown(true)}
                  onMouseLeave={() => setShowAboutDropdown(false)}
                >
                  <button
                    onClick={() => navigate('/about')}
                    className={`py-2 text-sm font-semibold border-b-2 transition-all hover:text-slate whitespace-nowrap flex items-center gap-1 ${
                      activeTab === tab.id
                        ? 'text-crimson border-crimson'
                        : 'text-gray-500 border-transparent'
                    }`}
                    style={{
                      padding: '6px 8px',
                      fontSize: '13px',
                      fontWeight: '600',
                      color: activeTab === tab.id ? '#981b1e' : '#6b7280',
                      borderBottom: activeTab === tab.id ? '2px solid #981b1e' : '2px solid transparent',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {tab.label}
                    <i className="fas fa-chevron-down text-[10px] opacity-50 transition-transform group-hover:rotate-180"></i>
                  </button>
                  
                  {/* Invisible bridge to prevent gap */}
                  <div className="absolute top-full left-0 w-full h-2 bg-transparent"></div>
                  
                  {showAboutDropdown && (
                    <div className="absolute top-full left-0 pt-2 w-56 z-50">
                      <div className="bg-white shadow-lg rounded-lg border border-gray-200 py-2">
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about/vision-mission');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Vision & Mission
                        </a>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about/chairman-message');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Chairman Message
                        </a>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about/secretary-message');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Secretary Message
                        </a>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about/joint-secretary-message');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Joint Secretary Message
                        </a>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about/director-message');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Director Message
                        </a>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/about');
                            setShowAboutDropdown(false);
                          }}
                          className="block px-4 py-3 text-sm hover:bg-gray-50 hover:text-crimson transition"
                        >
                          Approvals & Affiliations
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              );
            }
            
            return (
              <Link
                key={tab.id}
                to={tab.path}
                className={`py-2 text-sm font-semibold border-b-2 transition-all hover:text-slate whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'text-crimson border-crimson'
                    : 'text-gray-500 border-transparent'
                }`}
                style={{
                  padding: '6px 8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: activeTab === tab.id ? '#981b1e' : '#6b7280',
                  borderBottom: activeTab === tab.id ? '2px solid #981b1e' : '2px solid transparent',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap'
                }}
              >
                {tab.label}
              </Link>
            );
          })}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`${isDesktop ? 'hidden' : 'flex'} p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-crimson`}
            style={{
              display: isDesktop ? 'none' : 'flex',
              padding: '8px',
              borderRadius: '6px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer'
            }}
            aria-label="Toggle menu"
          >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isMobileMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu with Animation */}
      <div
        className={`${isDesktop ? 'hidden' : 'block'} border-t border-gray-200 overflow-hidden transition-all duration-300 ease-in-out`}
        style={{
          display: isDesktop ? 'none' : 'block',
          maxHeight: isMobileMenuOpen ? '500px' : '0',
          opacity: isMobileMenuOpen ? '1' : '0',
          transition: 'all 0.3s ease-in-out',
          overflow: 'hidden'
        }}
      >
        <div className="px-4 py-2 space-y-1">
          {tabs.map((tab) => {
            if (tab.id === 'about') {
              return (
                <div key={tab.id} className="space-y-1">
                  <Link
                    to={tab.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                      activeTab === tab.id
                        ? 'text-crimson bg-crimson/10'
                        : 'text-gray-700 hover:text-crimson hover:bg-gray-50'
                    }`}
                  >
                    {tab.label}
                  </Link>
                  {/* About Us submenu items */}
                  <div className="ml-4 space-y-1">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about/vision-mission');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Vision & Mission
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about/chairman-message');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Chairman Message
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about/secretary-message');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Secretary Message
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about/joint-secretary-message');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Joint Secretary Message
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about/director-message');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Director Message
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/about');
                        setIsMobileMenuOpen(false);
                      }}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-crimson hover:bg-gray-50 rounded-md transition-colors"
                    >
                      → Approvals & Affiliations
                    </a>
                  </div>
                </div>
              );
            }
            
            return (
              <Link
                key={tab.id}
                to={tab.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'text-crimson bg-crimson/10'
                    : 'text-gray-700 hover:text-crimson hover:bg-gray-50'
                }`}
              >
                {tab.label}
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;